import * as React from "react";
import SelectBase, { SelectOption } from "../../components/global/SelectBase";

const workAvails: SelectOption[] = [
  {
    label: "Monday",
    value: "avail_monday",
  },
  {
    label: "Tuesday",
    value: "avail_tuesday",
  },
  {
    label: "Wednesday",
    value: "avail_wednesday",
  },
  {
    label: "Thursday",
    value: "avail_thursday",
  },
  {
    label: "Friday",
    value: "avail_friday",
  },
  {
    label: "Saturday",
    value: "avail_saturday",
  },
  {
    label: "Sunday",
    value: "avail_sunday",
  },
];

const SelectAvailability = ({
  onChange,
  values,
}: {
  onChange: (ids?: string[]) => void;
  values: string[];
}) => {
  const selectedValues = React.useMemo<SelectOption[]>(
    () => workAvails?.filter((it) => values?.includes(it.value as string)) || [],
    [values]
  );

  return (
    <SelectBase
      options={workAvails}
      value={selectedValues}
      onChange={(newValue) => {
        const options = newValue as SelectOption[] | null;
        onChange(options?.map((it) => it.value as string));
      }}
      label="Availability"
      placeholder="Select..."
      isMulti={true}
      isSearchable={false}
    />
  );
};
export default SelectAvailability;
